// src/App.jsx
import { Routes, Route, Navigate } from 'react-router-dom';
import { ModalsProvider } from '@mantine/modals'; // Onay modalları için Provider
import { Notifications } from '@mantine/notifications'; // Bildirimler için bileşen
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css'; 
import Login from './pages/Login';
import MainPortal from './pages/MainPortal';
import BaseLayout from './layouts/BaseLayout'; // Sadece Navbar
import FleetLayout from './layouts/FleetLayout'; // Navbar + Sidebar
import Dashboard from './pages/VehicleMaintenanceTracking/Dashboard';
import VehiclesPage from './pages/VehicleMaintenanceTracking/VehiclesPage';
import MaintenancePage from './pages/VehicleMaintenanceTracking/MaintenancePage';
import ReportsPage from './pages/VehicleMaintenanceTracking/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import SubscriptionsPage from './pages/Subscriptions/SubscriptionsPage';
import CheckLayout from './layouts/CheckLayout';
import CheckPrint from './pages/Check/CheckDesigner';
import CompanyList from './pages/Check/CompanyList';
import PrinterSettings from './pages/Check/PrinterSettings';
import CheckReports from './pages/Check/CheckReports';
import IT_Dashboard from './pages/IT/IT_Dashboard';
import './index.css'
import DeviceList from './pages/IT/DeviceList';
import HumanResourcesPage from './pages/HumanResourcesPage';
import ITSupportPage from './pages/ITSupport/ITSupportPage';
import ITSupportAdminPage from './pages/ITSupport/ITSupportAdminPage';
import CorporateResourcesPage from './pages/CorporateResourcesPage';
import OfficeOperationsDashboard from './pages/OfficeOperations/OfficeOperationsDashboard';
import OfficeOperationsVehicle from './pages/OfficeOperations/OfficeOperationsVehicle';
import OfficeOperationsGuest from './pages/OfficeOperations/OfficeOperationsGuest';
import OfficeOperationsReports from './pages/OfficeOperations/OfficeOperationsReports';
import PurchaseReports from './pages/PurchaseOperations/PurchaseReports';
import RequestPage from './pages/PurchaseOperations/RequestPage';
import ApprovalPage from './pages/PurchaseOperations/ApprovalPage';
import PurchasingDashboard from './pages/PurchaseOperations/PurchasingDashboard';
import QuoteEntry from './pages/PurchaseOperations/QuoteEntry';
import QuoteSelection from './pages/PurchaseOperations/QuoteSelection';
import GoodsReceipt from './pages/PurchaseOperations/GoodsReceipt';
import ReturnManagement from './pages/PurchaseOperations/ReturnManagement';
import InvoiceManagement from './pages/PurchaseOperations/InvoiceManagement';
import NetworkPage from './pages/PurchaseOperations/NetworkPage';
import ScrollToTop from './components/ScrollToTop';
import ProfilePage from './pages/ProfilePage';
import BetonTakip from './pages/ConcreteTrack/ConcreteAdd';
import BetonRaporlari from './pages/ConcreteTrack/ConcreteReports';
import ConcreteDetailReports from './pages/ConcreteTrack/ConcreteDetailReports';
import BetonAyarlari from './pages/ConcreteTrack/ConcreteSettings';
import BetonMain from './pages/ConcreteTrack/ConcreteMain';
import IstanbulOfficeDashboard from './pages/IstanbulOffice/IstanbulOfficeDashboard';
import IstanbulOfficeExpense from './pages/IstanbulOffice/IstanbulOfficeExpense';
import IstanbulOfficeVehicle from './pages/IstanbulOffice/IstanbulOfficeVehicle';
import IstanbulOfficeGuest from './pages/IstanbulOffice/IstanbulOfficeGuest';
import IstanbulOfficeReport from './pages/IstanbulOffice/IstanbulOfficeReport';
import ArchiveVehicle from './pages/VehicleMaintenanceTracking/ArchiveVehicle';
import LogsPage from './pages/LogsPage';
import ResetPasswordPage from './pages/ResetPasswordPage'; // SÜSLÜ PARANTEZ YOK
import Changelog from './pages/Changelog';
import Endpoints from './pages/Endpoints';
import ProtectedRouteAdmin from './components/ProtectedRoutes'; // Dosya yoluna göre düzenleyin
import SupportDashboard from './pages/FinancialSupport/Dashboard'; // Dosya yoluna göre düzenleyin
import Families from './pages/FinancialSupport/Family';
import Students from './pages/FinancialSupport/Student';
import Warehouse from './pages/Warehouse/Warehouse';
import WarehouseDetail from './pages/Warehouse/WarehouseDetail';
import WarehouseSettings from './pages/Warehouse/WarehouseSettings';
import HrDashboard from './pages/HumanResources/Dashboard';
import HrLayout from './layouts/HrLayout';
import EmployeesPage from './pages/HumanResources/EmployeesPage';
import DocumentsPage from './pages/HumanResources/DocumentsPage';
import LeavesPage from './pages/HumanResources/LeavesPage';
import DefinitionsPage from './pages/HumanResources/DefinitionsPage';
import HRReportsPage from './pages/HumanResources/ReportsPage';
import FileShareLayout from './components/FileShare/FileShareLayout';
import {FileShareProvider} from './components/FileShare/FileShareContext';
import { Outlet } from "react-router-dom";
import FileShareDashboard from './pages/FileShare/FileShareDashboard';
import NewSharePage from './pages/FileShare/NewSharePage';
import MySharesPage from './pages/FileShare/MySharesPage';
import FileShareAdmin from './pages/FileShare/FileShareAdmin';
import PublicDownloadPage from './pages/FileShare/PublicDownloadPage';
import RealEstateDashboard from './pages/RealEstate/DashboardPage';
import RealEstateProperties from './pages/RealEstate/PropertiesPage';
import RealEstateLayout from './pages/RealEstate/RealEstateLayout';
import RealEstateDocuments from './pages/RealEstate/DocumentsPage';
import RealEstateReports from './pages/RealEstate/ReportsPage';
import ReleaseNotesPage from "./pages/ReleaseNotesPage";
import ReleaseNotesAdminPage from "./components/settings/ReleaseNotesAdminPage";
import TaskManagement from "./pages/TaskManagement/TaskManagement";
import PdfStudio from './pages/PdfStudio/PdfStudio.jsx';
import ITBudgetModule from './pages/ITBudget/ITBudgetModule.jsx';
import ManagementReportsPage from './pages/ManagementReports/ManagementReportsPage.jsx';

// Güvenlik Katmanı
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    // İŞTE BURASI: Tüm Route'ları ModalsProvider ile sarmalıyoruz
    <ModalsProvider>
        <ScrollToTop />

      
      {/* İŞTE BURASI: Toast bildirimlerinin ekranda çıkması için Notifications bileşeni */}
      <Notifications position="top-right" zIndex={1000} />

      <Routes>
        {/* --- HERKESE AÇIK SAYFALAR --- */}
        <Route path="/login" element={<Login />} />

        {/* --- ANA PORTAL & ABONELİKLER (Sadece Navbar VAR, Sidebar YOK) --- */}
        <Route element={
          <ProtectedRoute>
            <BaseLayout />
          </ProtectedRoute>
        }>
          <Route path="/" element={<MainPortal />} />
          <Route path="/subscriptions" element={<SubscriptionsPage />} />
          <Route path="/change-log" element={<Changelog />} />
    {/* Sadece Admin'e Açık Rotalar */}
          <Route
            path="/settings"
            element={
              <ProtectedRouteAdmin allowedRoles={['admin']}>
                <SettingsPage />
              </ProtectedRouteAdmin>
            }
          />
          <Route
            path="/logs"
            element={
              <ProtectedRouteAdmin allowedRoles={['admin']}>
                <LogsPage />
              </ProtectedRouteAdmin>
            }
          />
          <Route
            path="/endpoints"
            element={
              <ProtectedRouteAdmin allowedRoles={['admin']}>
                <Endpoints />
              </ProtectedRouteAdmin>
            }
          />

          <Route path="/management-reports" element={<ManagementReportsPage />} />
          <Route path="/inventory" element={<IT_Dashboard />} />
          <Route path="/it-budget" element={<ITBudgetModule />} />
          <Route path="/devices" element={<DeviceList />} />
          <Route path="/hr" element={<HumanResourcesPage />} />
          <Route path="/it-support" element={<ITSupportPage />} />
          <Route path="/it-support-admin" element={<ITSupportAdminPage />} />
          <Route path="/office-operations/dashboard" element={<OfficeOperationsDashboard />} />
          <Route path="/office-operations/vehicle-log" element={<OfficeOperationsVehicle />} />
          <Route path="/office-operations/guest-log" element={<OfficeOperationsGuest />} />
          <Route path="/office-operations/reports" element={<OfficeOperationsReports />} />
          <Route path="/corporate-resources" element={<CorporateResourcesPage />} />
          <Route path="/purchase-dashboard" element={<PurchasingDashboard />} />
          <Route path="/purchase-reports" element={<PurchaseReports />} />
          <Route path="/request" element={<RequestPage />} />
          <Route path="/approval" element={<ApprovalPage />} />
          <Route path="/quote-entry" element={<QuoteEntry />} />
          <Route path="/quote-selection" element={<QuoteSelection />} />
          <Route path="/goods-receipt" element={<GoodsReceipt />} />
          <Route path="/return-management" element={<ReturnManagement />} />
          <Route path="/invoice-management" element={<InvoiceManagement />} />
          <Route path="/network-page" element={<NetworkPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/beton-takip" element={<BetonMain />} />
          <Route path="/beton-takip/kayit" element={<BetonTakip />} />
          <Route path="/beton-takip/raporlar" element={<BetonRaporlari />} />
          <Route path="/beton-takip/detayli-raporlar" element={<ConcreteDetailReports />} />
          <Route path="/beton-takip/ayarlar" element={<BetonAyarlari />} />
          <Route path="/istanbul-office/dashboard" element={<IstanbulOfficeDashboard />} />
          <Route path="/istanbul-office/expense" element={<IstanbulOfficeExpense />} />
          <Route path="/istanbul-office/vehicle" element={<IstanbulOfficeVehicle />} />
          <Route path="/istanbul-office/guest" element={<IstanbulOfficeGuest />} />
          <Route path="/istanbul-office/reports" element={<IstanbulOfficeReport />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/financial-support" element={<SupportDashboard />} />
          <Route path="/financial-support/family" element={<Families />} />
          <Route path="/financial-support/student" element={<Students />} />
          <Route path="/warehouse" element={<Warehouse />} />
          <Route path="/warehouse/:id" element={<WarehouseDetail />} />
          <Route path="/warehouse/settings" element={<WarehouseSettings />} />

        
        </Route>

        <Route element={
          <ProtectedRoute>
            <CheckLayout />
          </ProtectedRoute>
        }>
          <Route path="/checks/print" element={<CheckPrint />} />
          <Route path="/checks/companies" element={<CompanyList />} />
          <Route path="/checks/templates" element={<PrinterSettings />} />
          <Route path="/checks/reports" element={<CheckReports />} />

        </Route>

          <Route path="/task-management" element={<TaskManagement />} />

        {/* --- FİLO YÖNETİM MODÜLÜ (FleetLayout ile Sarmalanmış - Sidebar VAR) --- */}
        <Route element={
          <ProtectedRoute>
            <FleetLayout />
          </ProtectedRoute>
        }>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/vehicles" element={<VehiclesPage />} />
          <Route path="/archive-vehicles" element={<ArchiveVehicle />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route path="/reports" element={<ReportsPage />} />
        </Route>

        <Route
          element={
            <FileShareProvider>
              <Outlet />
            </FileShareProvider>
          }
        >
          <Route path="/fileshare" element={<FileShareLayout />}>
            <Route index element={<FileShareDashboard />} />
            <Route path="new" element={<NewSharePage />} />
            <Route path="my-shares" element={<MySharesPage />} />
            <Route path="admin" element={<FileShareAdmin />} />
          </Route>

          {/* Herkese açık dosya indirme sayfası */}
          <Route
            path="/share/:token"
            element={<PublicDownloadPage />}
          />
        </Route>


        <Route
          path="/pdf-studio"
          element={
            <ProtectedRoute>
              <PdfStudio />
            </ProtectedRoute>
          }
        />


        {/* GAYRİMENKUL YÖNETİMİ */}
        <Route element={
          <ProtectedRoute>
            <RealEstateLayout />
          </ProtectedRoute>
        }>
          <Route
            path="/gayrimenkul"
            element={<Navigate to="/gayrimenkul/dashboard" replace />}
          />

          <Route
            path="/gayrimenkul/dashboard"
            element={<RealEstateDashboard />}
          />

          <Route
            path="/gayrimenkul/properties"
            element={<RealEstateProperties />}
          />

          <Route
            path="/gayrimenkul/documents"
            element={<RealEstateDocuments />}
          />

          <Route
            path="/gayrimenkul/reports"
            element={<RealEstateReports />}
          />
        </Route>

        <Route
          path="/release-notes"
          element={<ReleaseNotesPage />}
        />

        <Route
          path="/admin/release-notes"
          element={<ReleaseNotesAdminPage />}
        />

        <Route element={
          <ProtectedRoute>
            <HrLayout />
          </ProtectedRoute>
        }>
          <Route path="/hr/dashboard" element={<HrDashboard />} />
          <Route path="/hr/employees" element={<EmployeesPage />} />
          <Route path="/hr/documents" element={<DocumentsPage />} />
          <Route path="/hr/leaves" element={<LeavesPage />} />
          <Route path="/hr/reports" element={<HRReportsPage />} />
          <Route path="/hr/definitions" element={<DefinitionsPage />} />
        </Route>

        {/* --- GEÇERSİZ ROTA YAKALAYICI (Bilinmeyen adrese gireni Ana Portala at) --- */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ModalsProvider>
  );
}

export default App;